import {
  GET_COMMUNITY_PROFILE,
  RESET_COMMUNITY_PROFILE,
  START_LOADING_COMMUNITY,
  STOP_LOADING_COMMUNITY,
  ERROR_LOADING_COMMUNITY,
} from "./action-types";

import { Dispatch } from "redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";

export const fetchCommunityProfileAction =
  (communityId: string) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_COMMUNITY });
    try {
      const { data } =
        await apiLibrary.Communities.getCommunityProfile(communityId);

      dispatch({
        type: GET_COMMUNITY_PROFILE,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({ type: RESET_COMMUNITY_PROFILE });
      window.location.href = "/community/list";
      dispatch({ type: ERROR_LOADING_COMMUNITY });
    } finally {
      dispatch({ type: STOP_LOADING_COMMUNITY });
    }
  };
export const resetCommunityProfileAction = () => {
  return {
    type: RESET_COMMUNITY_PROFILE,
  };
};

// export const getMyProfileSuccessAction = (res: any) => {
//   return {
//     type: getMyProfileSuccess,
//     payload: res,
//   };
// };

// export const updateContactPrefrencesAction = (res: any) => {
//   return {
//     type: updateContactPrefrences,
//     payload: res,
//   };
// };

// export const updateSocialAccountsAction = (res: any) => {
//   return {
//     type: updateSocialaccounts,
//     payload: res,
//   };
// };

// export const resetData = (res: any) => {
//   return {
//     type: "RESET_USER_DATA",
//     payload: res,
//   };
// };
